// extracted by mini-css-extract-plugin
export default {"effectParams":"Effects_effectParams__GPQMu","effectToggleContainer":"Effects_effectToggleContainer__ZeinG"};